'use client';

import { ChirpStaticEnvironments } from '@chewy/chirp-theme-provider';
import { ChirpIllustration } from '@chewy/chirp-media-kit/illustration/illustration.js';
import useEnv from '@/hooks/useEnv';
import JavascriptBridge from '@/utils/JavascriptBridge';
import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './serviceErrorPage.module.scss';

const ServiceErrorPage = () => {
  const { chewyEnv = 'prd' } = useEnv();
  const chirpEnv = chewyEnv.toUpperCase() as ChirpStaticEnvironments;

  useEffect(() => {
    JavascriptBridge.getInstance().analyticsEvent('pageLoaded', {
      event_name: 'Screen Viewed',
      screen_name: 'Service Error Page'
    });
  }, []);

  return (
    <div className={cn('chirp-light-mode-lock', styles.containerStyle)}>
      <div className={styles.contentContainer}>
        <div className={styles.imageContainer}>
          <ChirpIllustration className={styles.errorImage} isDecorative={true} env={chirpEnv} name="illo-largespot-404error" />
        </div>
        <div className={styles.messageContainer}>
          <p data-testid="service-error-message1" className={styles.messageStyle}>{`We're having trouble fetching this page right now.`}</p>
          <p data-testid="service-error-message2" className={styles.messageBStyle}>
            {`If you need immediate assistance, please call us at `}
            <a href="tel:1-800-672-4399">1-800-672-4399</a>
            {`—we're here to help.`}
          </p>
          <p data-testid="service-error-message3" className={styles.messageBStyle}>
            <button data-testid="service-error-message3-button" className={styles.messageBStyleButton} onClick={() => window.location.reload()}>{`Please reload the page`}</button>
          </p>
        </div>
      </div>
    </div>
  );
};
export default ServiceErrorPage;
